/** Advokatsamfundets persondatapolitik. Bekræftet 2026-08-31: intet redirect. */
export const PERSONDATAPOLITIK_URL =
  "https://advokatsamfundet.dk/om-advokatsamfundet/persondatapolitik/";
